import { ANDROID_BRAND_PATTERN, ANDROID_USER_AGENT_PATTERN } from './get-device-by-user-agent';

export const isMobileApproaching = () => {
  if (typeof window === 'undefined') return false;
  const userAgent = navigator.userAgent;
  if (
    userAgent.match(ANDROID_USER_AGENT_PATTERN) != null ||
    userAgent.match(ANDROID_BRAND_PATTERN) != null
  ) {
    return true;
  }

  return false;
};
